import { render, staticRenderFns } from "./DragAndDropImageContainer.vue?vue&type=template&id=003a0cc7&scoped=true&"
import script from "./DragAndDropImageContainer.vue?vue&type=script&lang=ts&"
export * from "./DragAndDropImageContainer.vue?vue&type=script&lang=ts&"
import style0 from "./DragAndDropImageContainer.vue?vue&type=style&index=0&id=003a0cc7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003a0cc7",
  null
  
)

export default component.exports